<fq-maintenance-banner></fq-maintenance-banner>
<app-header
  [navbarBrandRouterLink]="['/awpDashboard/dashboard']"
  [fixed]="true"
  [navbarBrandFull]="{src: 'assets/img/brand/' + projectLogo, width: 89, height: 25, alt: projectName}"
  [navbarBrandMinimized]="{src: 'assets/img/brand/' + projectLogoMinimized, width: 89, height: 25, alt: projectName}"
  [sidebarToggler]="'lg'"
  [asideMenuToggler]="activeAside"
  (sidebarToggled)="onSidebarToggled()"
  (asideToggled)="aside = !aside">

  <ul class="nav navbar-nav navbar-nav-left" headerLeft>
    <li class="nav-item">
      <app-header-favorites></app-header-favorites>
    </li>
  </ul>

  <app-header-site-search headerCenter></app-header-site-search>

  @if (showLiveEvents) {
    <li class="hidden min-[992px]:block">
      <fq-event-monitor></fq-event-monitor>
    </li>
  }

  <li class="nav-item">
    <fuseq-support-menu></fuseq-support-menu>
  </li>

  <li class="ml-1 hidden h-6 w-px bg-white/20 min-[992px]:block" aria-hidden="true"></li>

  <li class="relative">
    <a class="header-action cursor-pointer" href="#" role="button" aria-haspopup="true" aria-expanded="false" (click)="userDropdownOpen = !userDropdownOpen; eventDropdownOpen = false">
      <fa-icon [icon]="['fas', 'user']"></fa-icon> {{currentUser.username}}
    </a>
    @if (userDropdownOpen) {
      <div class="absolute right-0 top-full z-50 mt-1 min-w-[10rem] rounded-md border border-fq-border-soft bg-fq-surface py-1 shadow-lg">
        <div class="px-4 py-2 text-center text-sm text-fq-text-muted"><strong>Account</strong></div>
        <a class="clickable block w-full cursor-pointer px-4 py-2 text-sm text-fq-text-2 hover:bg-fq-surface-muted" (click)="logout(); userDropdownOpen = false"><fa-icon [icon]="['fas', 'lock']"></fa-icon> Logout</a>
      </div>
    }
  </li>

  <li class="relative">
    <a class="header-action header-action-icon mr-1 cursor-pointer" href="#" role="button" aria-haspopup="true" aria-expanded="false" (click)="eventDropdownOpen = !eventDropdownOpen; userDropdownOpen = false">
      <fa-icon [icon]="['fas', 'bell']"></fa-icon>@if (notificationCount().total > 0) {
      <span class="header-badge" [class.is-read]="checkAllRead(notificationCount().details)">{{notificationCount().total}}</span>
    }
  </a>
  @if (eventDropdownOpen) {
    <div class="absolute right-0 top-full z-50 mt-1 min-w-[10rem] rounded-md border border-fq-border-soft bg-fq-surface py-1 shadow-lg">
      <div class="px-4 py-2 text-center text-sm text-fq-text-muted"><strong>Events</strong></div>
      @for (detail of notificationCount().details; track detail.name) {
        <a class="clickable block w-full cursor-pointer px-4 py-2 text-sm text-fq-text-2 hover:bg-fq-surface-muted" (click)="notification(detail); eventDropdownOpen = false"><i class="{{detail.icon}}"></i> {{detail.label}}@if (detail.count > 0) {
        <span class="inline-flex items-center px-2 py-0.5 text-xs font-bold text-white bg-fq-info rounded" [ngClass]="detail.notReadCount == 0 ? 'badge-read' : 'badge-notRead'">{{detail.count}}</span>
      }</a>
    }
</div>
}
</app-header>
<div class="app-body" [class.sidebar-minimized]="sidebarMinimized()">
  <app-sidebar #appSidebar [fixed]="true" [display]="'lg'" [minimized]="sidebarMinimized()" [show]="sidebarShown" (minimizedChange)="toggleMinimize($event)">
    <app-sidebar-nav [navItems]="navItems()" [minimized]="sidebarMinimized()" (itemClicked)="sidebarShown = false"></app-sidebar-nav>
    <app-sidebar-minimizer [minimized]="sidebarMinimized()" (click)="toggleMinimize(!sidebarMinimized())"></app-sidebar-minimizer>
  </app-sidebar>

  <main class="main">
    <ngx-ui-loader></ngx-ui-loader>
    <div class="flex min-h-full w-full flex-col bg-fq-body px-[25px]">
      <router-outlet></router-outlet>
    </div>
  </main>

  <app-aside [fixed]="true" [display]="aside" (closed)="aside = false" class="test">
    <div class="aside-shell">
      <header class="aside-header">
        <div class="flex min-w-0 items-center gap-3">
          <div class="aside-header-icon">
            <fa-icon [icon]="['fas', 'bell']" aria-hidden="true"></fa-icon>
          </div>
          <div class="min-w-0">
            <div class="text-sm font-bold leading-tight text-fq-heading">Notifiche</div>
            <div class="truncate text-xs text-fq-text-muted">Eventi e attività in tempo reale</div>
          </div>
        </div>
        <button type="button" class="aside-close" aria-label="Chiudi notifiche" (click)="aside = false">
          <fa-icon [icon]="['fas', 'xmark']" aria-hidden="true"></fa-icon>
        </button>
      </header>

      <p-tabs #notificationsTabset [value]="0">
        <p-tablist>
          @for (raiden of raidenList(); track raiden.name; let i = $index) {
            <p-tab [value]="i" [class.hideTab]="!checkSidebar(raiden)" [title]="raiden.optionName || raiden.name">
              <i class="{{raiden.icon}}" aria-hidden="true"></i>
              @if (raiden.name == 'CalendarEvents') {
                @if (activeTasksList().length > 0) {
                  <span class="aside-tab-count is-unread">{{ activeTasksList().length }}</span>
                }
              } @else if (raiden.name != 'Settings' && raiden.data.length > 0) {
                <span class="aside-tab-count" [ngClass]="checkAllRead(raiden.data) ? 'is-read' : 'is-unread'">{{ raiden.data.length }}</span>
              }
            </p-tab>
          }
        </p-tablist>

        <p-tabpanels>
          @for (raiden of raidenList(); track raiden.name; let i = $index) {
            <p-tabpanel [value]="i">

              @if (raiden.name != 'CalendarEvents' && raiden.name != 'Settings' && checkSidebar(raiden)) {
                <div class="aside-panel">
                  <div class="aside-panel-toolbar">
                    <span class="text-[11px] font-bold uppercase tracking-wide text-fq-text-muted">
                      {{ raiden.data.length }} {{ raiden.data.length === 1 ? 'notifica' : 'notifiche' }}
                    </span>
                    @if (raiden.data.length > 0) {
                      <div class="flex items-center gap-1">
                        <button type="button" class="aside-tool" pTooltip="Segna tutte come lette" tooltipPosition="bottom" appendTo="body" (click)="markAllAsRead(raiden)">
                          <fa-icon [icon]="['fas', 'envelope-open']" aria-hidden="true"></fa-icon>
                        </button>
                        <button type="button" class="aside-tool" pTooltip="Svuota" tooltipPosition="bottom" appendTo="body" (click)="clearAll(raiden)">
                          <fa-icon [icon]="['fas', 'trash-can']" aria-hidden="true"></fa-icon>
                        </button>
                      </div>
                    }
                  </div>

                  @if (raiden.data.length === 0) {
                    <div class="aside-empty">
                      <fa-icon [icon]="['fas', 'inbox']" aria-hidden="true"></fa-icon>
                      <span>Nessuna notifica</span>
                    </div>
                  } @else {
                    <div class="grid gap-2">
                      @for (msg of raiden.data; track msg.uniqueId) {
                        <article class="aside-card" [class.is-unread]="!msg.markAsRead" [class.is-read]="msg.markAsRead">
                          <div class="flex items-start justify-between gap-2">
                            <span class="text-[11px] font-semibold uppercase tracking-wide text-fq-text-muted">{{ msg.title }}</span>
                            <button type="button" class="aside-tool -mt-1 -mr-1" [attr.aria-label]="msg.markAsRead ? 'Segna come non letta' : 'Segna come letta'" (click)="toggleRead(raiden, msg)">
                              <fa-icon [icon]="['fas', msg.markAsRead ? 'envelope-open' : 'envelope']" aria-hidden="true"></fa-icon>
                            </button>
                          </div>
                          <div class="mt-0.5 text-sm font-bold leading-snug text-fq-text">{{ msg.name }}</div>
                          <p class="mt-0.5 text-xs leading-snug text-fq-text-muted">{{ msg.description }}</p>
                          <div class="mt-2 flex items-center justify-between text-[11px] font-bold uppercase tracking-wide text-fq-text-muted">
                            <span class="truncate">{{ msg.progress }}</span>
                            <span class="ml-2 shrink-0">{{ msg.percent }}%</span>
                          </div>
                          <div class="mt-1 h-1.5 overflow-hidden rounded-full bg-fq-surface-muted" role="progressbar" [attr.aria-valuenow]="msg.percent" aria-valuemin="0" aria-valuemax="100">
                            <div class="h-full rounded-full bg-fq-info transition-[width]" [style.width]="msg.percent + '%'"></div>
                          </div>
                        </article>
                      }
                    </div>
                  }
                </div>
              }

              @if (raiden.name == 'CalendarEvents' && checkSidebar(raiden)) {
                <div class="aside-panel">
                  <div class="aside-panel-toolbar">
                    <span class="text-[11px] font-bold uppercase tracking-wide text-fq-text-muted">Attività attive</span>
                    <span class="aside-tab-count is-read">{{ activeTasksList().length }}</span>
                  </div>
                  @if (activeTasksList().length === 0) {
                    <div class="aside-empty">
                      <fa-icon [icon]="['fas', 'calendar']" aria-hidden="true"></fa-icon>
                      <span>Nessuna attività in corso</span>
                    </div>
                  } @else {
                    <div class="grid gap-2">
                      @for (task of activeTasksList(); track task.frazionario + '-' + task.task) {
                        <div class="aside-card">
                          <div class="text-sm font-bold text-fq-text">{{ task.frazionario }}</div>
                          <div class="text-xs text-fq-text-2">{{ task.task }}</div>
                          <div class="mt-1.5 flex flex-wrap items-center gap-3 text-[11px] text-fq-text-muted">
                            <span class="inline-flex items-center gap-1">
                              <fa-icon [icon]="['fas', 'calendar']" aria-hidden="true"></fa-icon> {{ task.time }}
                            </span>
                            <span>{{ task.category }}</span>
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
              }

              @if (raiden.name == 'Settings') {
                <div class="aside-panel">
                  <div class="aside-settings-card">
                    @for (setting of raidenList(); track setting.name) {
                      @if (setting.showOptions) {
                        <div class="aside-setting-group">
                          <div class="aside-setting-title">{{ setting.optionName }}</div>
                          @for (option of setting.options; track option.name) {
                            <div class="aside-setting-row">
                              <span>{{ option.name }}</span>
                              <p-toggleswitch [(ngModel)]="option.active" (onChange)="changeSettings()" />
                            </div>
                          }
                        </div>
                      }
                    }
                  </div>
                  <div class="aside-settings-card">
                    <div class="aside-setting-row">
                      <span>Dark mode</span>
                      <p-toggleswitch [ngModel]="isDarkMode" (onChange)="toggleDarkMode()" />
                    </div>
                  </div>
                </div>
              }

            </p-tabpanel>
          }
        </p-tabpanels>
      </p-tabs>
    </div>
  </app-aside>
  </div>

  <app-footer (mouseenter)="freeze()" (mouseleave)="unfreeze()">
    @for (client of isFrozen() ? roomClients() : roomClients(); track client.socket_id) {
      <p-tag class="mr-2" icon="fa fa-user" value="{{client.user_id}}{{client.reaction ? ' (' + client.reaction + ')' : ''}}" pTooltip="On this page since: {{client.joined_at}}" tooltipPosition="top" appendTo="body" (click)="sendReaction(client.socket_id)"></p-tag>
    }
  </app-footer>

